import { Place } from './places';

const emoji: Record<string, string> = {
  'A': '🇦',
  'B': '🇧',
  'C': '🇨',
  'D': '🇩',
  'E': '🇪',
  'F': '🇫',
  'G': '🇬',
  'H': '🇭',
  'I': '🇮',
  'J': '🇯',
  'K': '🇰',
  'L': '🇱',
  'M': '🇲',
  'N': '🇳',
  'O': '🇴',
  'P': '🇵',
  'Q': '🇶',
  'R': '🇷',
  'S': '🇸',
  'T': '🇹',
  'U': '🇺',
  'V': '🇻',
  'W': '🇼',
  'X': '🇽',
  'Y': '🇾',
  'Z': '🇿',
};

export default function flagForPlace(place: Place): string {
  return place.countryCode.split('')
    .map(letter => emoji[letter])
    .join('');
}
